import { render } from "./SupplyChainPage.vue?vue&type=template&id=7dae4a90&scoped=true"
import script from "./SupplyChainPage.vue?vue&type=script&lang=js"
export * from "./SupplyChainPage.vue?vue&type=script&lang=js"

import "./SupplyChainPage.vue?vue&type=style&index=0&id=7dae4a90&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/freelance/naks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dae4a90"]])

export default __exports__